import { render, staticRenderFns } from "./groupFriend.vue?vue&type=template&id=f30b0d6e&scoped=true"
import script from "./groupFriend.vue?vue&type=script&lang=js"
export * from "./groupFriend.vue?vue&type=script&lang=js"
import style0 from "./groupFriend.vue?vue&type=style&index=0&id=f30b0d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30b0d6e",
  null
  
)

export default component.exports